import { Context as PosContext } from '@squareup/sq-addons-web-sdk';

import { SquareLoyaltyApiError } from 'store/api/errors';

const DELETE_REWARD_API_ENDPOINT_PATH = '/v2/loyalty/rewards/';

export async function deleteReward(posContext: PosContext, rewardId: string) {
  const squareDomain = posContext.configurations.environmentUrl as string;

  const deleteRewardResponse = await fetch(
    `${squareDomain}${DELETE_REWARD_API_ENDPOINT_PATH}${rewardId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Square-Version': '2023-12-13',
      },
    }
  ).then((result) => result.json());

  if (deleteRewardResponse.errors?.length > 0) {
    const error = deleteRewardResponse.errors[0];

    throw new SquareLoyaltyApiError({
      code: error.code,
      message:
        error.detail || 'Error calling the Square Loyalty Delete Reward API',
    });
  }
}
